module.exports = __webpack_public_path__ + "static/img/51.5d136c53.gif";